export default {"src":"/_next/static/media/opd_insurance_filled.2c4b3579.svg","height":72,"width":72,"blurWidth":0,"blurHeight":0};